import Model from "./Model";

export default class extends Model {
    async loadTable(page, limit, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(worktime => {
                let telem = {
                    tbody: {}
                };
                telem.id = worktime.id;
                telem.tbody.mon_start = worktime.mon_start;
                telem.tbody.mon_end = worktime.mon_end;
                telem.tbody.tue_start = worktime.tue_start;
                telem.tbody.tue_end = worktime.tue_end;
                telem.tbody.wed_start = worktime.wed_start;
                telem.tbody.wed_end = worktime.wed_end;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
